/** Ноль, отрицательные, NaN и бесконечность одинаково негодны как размер для геометрии. */
export function isPositiveSize(...sizes: readonly number[]): boolean {
  return sizes.every(size => Number.isFinite(size) && size > 0);
}
